export default __webpack_public_path__ + "static/media/dislike.06941e4b.svg";